"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  box-shadow: 0px 2px 4px #00000040;\n  width: 197px;\n  border-radius: 5px;\n  position: ", ";\n  top: ", ";\n  left: ", ";\n  transform: ", ";\n  z-index: 500;\n  background-color: white;\n\n  .search-cotainer {\n    display: flex;\n    padding-left: 10px;\n    align-items: center;\n    border-bottom: 1px solid #f0f0f0;\n\n    svg {\n      & + * {\n        margin-left: 10px;\n      }\n    }\n\n    input {\n      border: none;\n      width: 100%;\n      padding: 10px;\n      outline: none;\n    }\n  }\n\n  .selector-container {\n    max-height: 184px;\n    overflow: auto;\n    .user-item {\n      display: flex;\n      font-family: ", ";\n      font-size: 12px;\n      align-items: center;\n      padding: 10px;\n      cursor: pointer;\n\n      &:hover {\n        background-color: #f0f0f0;\n      }\n\n      > * + * {\n        margin-left: 10px;\n      }\n    }\n  }\n"])), function (_ref) {
  var position = _ref.position;
  return position ? position : "initial";
}, function (_ref2) {
  var position = _ref2.position;
  return position ? "100%" : "initial";
}, function (_ref3) {
  var position = _ref3.position;
  return position ? "50%" : "initial";
}, function (_ref4) {
  var position = _ref4.position;
  return position ? "translateX(-50%)" : "initial";
}, _variables.FontFamily.Lato);

exports.Container = Container;